module.exports = __webpack_public_path__ + "trivia_icon.png?4ce0b2c77f7f0ec437afb71ba02c9b78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/trivia_icon.png
// module id = 217
// module chunks = 0